<template>
  <div>
    <v-list>
      <template v-if="tabData.items.length > 0">
        <v-hover
          v-slot:default="{ hover }"
          v-for="item in tabData.items"
          :key="item.id"
        >
          <v-list-item :data-test="item.title" @click="handleClickItem(item)">
            <v-list-item-avatar
              :color="item.icon.bg"
              size="40"
              v-if="item.icon !== 'none'"
            >
              <template v-if="item.avatar">
                <v-img width="40" height="40" :src="item.avatar" />
              </template>
              <template v-else>
                <v-icon :color="item.icon.color" v-if="item.icon">
                  {{ item.icon.name }}
                </v-icon>
                <span class="white--text headline" v-else-if="item.initials">
                  {{ item.initials }}
                </span>
              </template>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title v-if="item.title">
                {{ item.title }}
              </v-list-item-title>

              <v-list-item-subtitle
                v-for="subtitle in item.subtitles"
                :key="subtitle"
              >
                {{ subtitle }}
              </v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-action v-if="item.isHoverAction">
              <v-btn
                @click="handleContext('detail-notification', item)"
                v-if="item.action === 'info'"
                slot="activator"
                v-show="hover || $vuetify.breakpoint.mdAndDown"
                class="table-button-context"
                icon
              >
                <v-icon>mdi-information</v-icon>
              </v-btn>
              <dropdown-menu
                v-else-if="item.action !== 'copy'"
                item-key-text="text"
                itemKeyValue="id"
                :items="item.contextMenu"
                :hover="hover"
                @input="handleContext($event, item)"
              >
                <template v-slot:activator="{ on }">
                  <slot name="activator" :on="on">
                    <v-btn
                      slot="activator"
                      v-show="hover || $vuetify.breakpoint.mdAndDown"
                      v-on="on"
                      :data-test-ctx-menu="item.title"
                      class="table-button-context"
                      icon
                    >
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </slot>
                </template>
              </dropdown-menu>
              <v-btn
                @click="copyText(item)"
                v-else
                slot="activator"
                v-show="hover || $vuetify.breakpoint.mdAndDown"
                class="table-button-context"
                icon
              >
                <v-icon>mdi-image-filter-none</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-hover>
      </template>
      <template v-for="(item, index) in tabData.additionalItems">
        <v-list-item
          :data-test-additional="item.title"
          :key="index"
          @click="$emit('action', item)"
          v-if="item.action !== 'show-full-logs'"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon.name }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>
              {{ item.title }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>
  </div>
</template>

<script>
import DropdownMenu from '@/components/DropdownMenu';
import AvatarItem from '@/components/appTable/avatarItem';

export default {
  name: 'AppEntityTabList',
  components: { AvatarItem, DropdownMenu },
  props: {
    tabData: {
      type: Object,
      default: () => ({})
    },
    isNestedEntity: {
      type: Boolean,
      default: false
    }
  },
  setup(props, context) {
    const handleContext = (action, ctx) => {
      const eventPayload = {
        actionName: action,
        context: ctx,
        id: typeof ctx === 'string' ? ctx : ctx.id
      };
      context.emit('action', eventPayload);
    };
    const handleClickItem = item => {
      if (!props.isNestedEntity && item.actionClickElement) {
        item.actionClickElement();
      }
    };
    const copyText = e => {
      context.root.$copyText(e).catch(err => {
        console.error(`Cannot copy: ${err}`);
      });
    };

    return {
      handleContext,
      copyText,
      handleClickItem
    };
  }
};
</script>
